import * as React from 'react';
import * as styles from '../styles/header.module.scss';
import { Link, navigate } from 'gatsby';
import Nav from './Nav';
import { useStaticQuery, graphql } from 'gatsby';

function Header({ siteTitle, logo }) {
  const result = useStaticQuery(
    graphql`
      {
        cms {
          pages(where: { type: "connect_company" }) {
            title
            slug
            sites {
              url
            }
          }
        }
      }
    `,
  );

  const connectCompanyPage = result.cms.pages.filter((page) =>
    page.sites.some((site) => site.url === process.env.GATSBY_FRONTEND_DOMAIN),
  )[0];

  return (
    <header className={styles.header}>
      <div className={`grid cols-3 ${styles.headerGrid}`}>
        <div>
          <Nav />
        </div>
        <div className="center">
          <Link to="/">
            <div
              style={{
                position: 'relative',
              }}
            >
              <img src={logo} alt={siteTitle} />
              <img
                src={`https://cfsspace.fra1.cdn.digitaloceanspaces.com/part-of-servicestart-${
                  process.env && process.env.GATSBY_USER_LOCALE
                }.png`}
                alt="Part of Servicestart"
                width="auto"
                height={16}
                style={{
                  position: 'absolute',
                  top: 40,
                  right: 0,
                }}
              />
            </div>
          </Link>
        </div>
        <div>
          <button
            className="right"
            onClick={() => navigate(`/${connectCompanyPage.slug}`)}
          >
            {connectCompanyPage.title}
          </button>
        </div>
      </div>
    </header>
  );
}
export default Header;
